<template>
  <div class="announcements">
    <a-card
      :bordered="false"
      class="header-solid mb-24"
      :bodyStyle="{ padding: '16px 0' }"
    >
      <div class="mx-25">
        <a-row type="flex" :gutter="24">
          <a-col
            :span="24"
            class="text-right"
            style="gap: 10px; display: inline-flex; flex: 1; flex-flow: wrap"
          >
            <a-input
              v-model="query"
              placeholder="公告标题"
              allowClear
              style="width: 180px"
            />
            <a-button type="primary" @click="search">搜索</a-button>
          </a-col>
        </a-row>
      </div>
    </a-card>
    <!-- Orders List card -->
    <a-card
      :bordered="false"
      class="header-solid mb-24"
      :bodyStyle="{ padding: 0, paddingTop: '16px' }"
    >
      <!-- Table search -->
      <div class="mx-25">
        <a-row type="flex" :gutter="24">
          <a-col :span="12" class="text-left">
            <h5 class="font-semibold">公告列表</h5>
          </a-col>
        </a-row>
      </div>
      <div style="margin: 10px 30px">
        <a-list item-layout="horizontal" :data-source="announceData">
          <a-list-item
            slot="renderItem"
            slot-scope="item, index"
            @click="goToLink(item)"
          >
            <a-list-item-meta :description="item.msgContent">
              <span slot="title" class="urlTitle">{{ item.title }}</span>
            </a-list-item-meta>
            <div>{{ item.validPeriodStart || item.updateTime }}</div>
          </a-list-item>
        </a-list>
        <a-pagination
          v-if="total"
          v-model:current="pages.pageNo"
          :defaultPageSize="pages.pageSize"
          @change="onChange"
          :total="total"
        />
      </div>
    </a-card>
  </div>
</template>

<script>
import { getNoticeList } from "./apis";

export default {
  data() {
    return {
      statusList: [],
      searchForm: {
        title: undefined,
      },

      // Table rows
      announceData: [],
      // Table page size
      pages: {
        pageSize: 10,
        pageNo: 1,
      },
      // Table search query
      query: "",
      total: null,
    };
  },
  methods: {
    search() {
      this.searchForm.title = this.query;
      this.getList(true);
    },
    goToLink(item) {
      item.contentType == "1"
        ? this.$router.push(`/pages/announcements/announceDetail?id=${item.id}`)
        : window.open(item.externalLink, "_blank");
    },
    async getList(resetPage) {
      resetPage && (this.pages.pageNo = 1);
      const res = await getNoticeList({
        ...this.searchForm,
        ...this.pages,
      });
      this.announceData = res.records;
      this.total = res.total || 0;
    },
    onChange(page) {
      this.pages.pageNo = page;
      this.getList();
    },
  },
  mounted() {
    this.getList(true);
  },
};
</script>

<style lang="scss" scoped>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}
.table-avatar-info {
  display: flex;
  align-items: center;
}
.table-avatar-info .ant-avatar {
  margin-right: 8px;
}

// Using vuejs "Deep Selectors"
.table-avatar-info::v-deep .ant-avatar-string {
  font-size: 12px;
}
.btn-status::v-deep .anticon {
  line-height: 0;
}
.flex_btn {
  display: flex;
  justify-content: space-between;
}
.urlTitle {
  color: #1890ff;
  text-decoration: underline;
  cursor: pointer;
}
.announcements::v-deep .ant-list-item {
  column-gap: 10px;
}
</style>
